import React from 'react';
import { List } from 'antd';
import { View } from '@components';
import styled, { css } from 'styled-components';
import Empty from '../Empty';

const ListItem = styled(List.Item)`
  display: flex;
  padding: 10px;
  border-radius: 3px;
  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
      &:hover {
        background: rgba(60, 90, 100, 0.04);
      }
    `}
`;

const ListComponent = ({ ...props }) => <List {...props} />;

ListComponent.propTypes = {
  ...List.propTypes,
};

ListComponent.defaultProps = {
  locale: {
    emptyText: <Empty description="Sem dados" />,
  },
};

ListComponent.Item = ListItem;

const GroupList = styled(View)`
  display: flex;
  flex-direction: row;
`;

const ListHeader = styled(View)`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

const Header = styled(View)`
  padding: 10px;
  font-size: 20px;
  font-weight: bold;
`;

const ListHeaderOpcoes = styled(Header)`
  padding-right: 43px;
  padding-left: 18px;
  text-align: right;
`;

const ListColumnOpcoes = styled(View)`
  font-size: 20px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export { ListComponent, ListHeader, Header, ListHeaderOpcoes, GroupList, ListColumnOpcoes };
